import TrailerTypeIcon from "./TrailerFormIcon";

export default TrailerTypeIcon;
